import { fetchAllSpecialClasses } from '@actions/specialClasses';
import AllSpecialClasses from '@cont/SpecialClassSeeAll/AllSpecialClasses';
import { getParameterByName } from '@utils/textHelper';
import setupInitialProps from '@utils/setupInitialProps';
import Layout from '@layout/index';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';
import { fetchTopologyInfo } from '@actions/topologies';

const AllSpecialClassesPage = ({ subjectUid }) => {
  return <AllSpecialClasses subjectUid={subjectUid} />;
};

AllSpecialClassesPage.pageInfo = {
  isMWebSupported: true,
  name: 'Special Class See all',
  layoutOptions: {
    showPlusNav: true
  },
  seeAll: true,
  isCMSMeta: true
};

export default AllSpecialClassesPage;

AllSpecialClassesPage.getInitialProps = setupInitialProps(async (context) => {
  const { store, isServer, asPath, query } = context;
  const subjectUid = getParameterByName('subject', asPath);
  const { goalUID, goalSlug } = query;
  await store.dispatch(fetchAllSpecialClasses(subjectUid, true));
  await store.dispatch(fetchTopologyInfo(goalUID));
  const goalName = store.getState().topologies?.data[goalUID]?.title;
  const metaTitle = `All ${goalName} Classes for Your Selected Subject`;
  const metaDescription = `Browse all classes in the ${goalName} goal for your chosen subject with detailed concept lessons, expert guidance, and structured learning to support consistent progress.`;
  const canonicalURL = `https://unacademy.com/goal/${goalSlug}/${goalUID}/classes/all${subjectUid}`;

  return {
    isServer,
    subjectUid,
    pageMetaInfo: {
      title: metaTitle,
      description: metaDescription,
      url: canonicalURL
    }
  };
}, AllSpecialClassesPage.pageInfo);
AllSpecialClassesPage.Layout = Layout;
AllSpecialClassesPage.Wrapper = PageReduxProvider;
